import { AlertIcon } from '#assets/ReactSvg.ts';
import { ConfirmDialog } from '#components/patterns/confirmations/confirm-dialog/ConfirmDialog.tsx';
import styles from './DeleteLighthouseWarning.module.css';

type Props = {
  onCancel: () => void;
  onAccept: () => void;
};

/**
 * {@link DeleteLighthouseWarning} is a modal that warns the user that they can't delete the last lighthouse.
 */
export function DeleteLighthouseWarning({ onCancel, onAccept }: Props) {
  return (
    <ConfirmDialog
      isOpen={true}
      onCancel={onCancel}
      onAccept={onAccept}
      title={
        <div className={styles.DeleteLighthouseWarning_title}>
          <AlertIcon className="mr-4" />
          Deleting last lighthouse
        </div>
      }
    >
      <p className="p">
        Deleting your last active lighthouse will prevent new connections between hosts from being formed.
      </p>
    </ConfirmDialog>
  );
}
